import type { Messages } from './en.js';

export const es: Messages = {
  'app.title': 'Sync Port · transferencia de archivos P2P',
  'secure.badge': 'Cifrado de extremo a extremo · de dispositivo a dispositivo · nada se guarda en ningún servidor',
  'secure.tooltip':
    'Los canales de datos WebRTC se cifran con DTLS entre los dos dispositivos. El servidor y el relé TURN solo ven datos cifrados.',
  'error.title': 'Transmisión perdida',
  'error.peerFailed': 'La conexión directa ha fallado. Revisa la red o la configuración del relé TURN.',
  'error.signaling': 'No se pudo contactar con el servidor de señalización.',
  'error.roomNotFound': 'No hay ninguna transferencia abierta con este enlace o PIN. Puede que el remitente cerrara la página o que el código esté mal escrito.',
  'error.roomFull': 'Otra persona ya abrió este enlace. Cada enlace sirve para un solo receptor.',
  'notFound.tagline': 'En esta coordenada solo hay espacio vacío.',
  'notFound.text': 'La página que abriste no existe.',
  'notFound.action': 'Enviar un archivo',
  'action.startOver': 'Empezar de nuevo',
  'action.retry': 'Reintentar',
  'action.cancel': 'Cancelar',
  'action.dismiss': 'Cerrar',
  'sender.tagline': 'Envía archivos entre dispositivos por un enlace privado y cifrado. Nada se queda en órbita.',
  'drop.title': 'Elige un archivo para enviar',
  'drop.hint': 'Toca o arrastra un archivo aquí · cualquier tamaño',
  'share.title': 'Comparte este enlace',
  'share.text': 'Ábrelo en el otro dispositivo o escanea el código con la cámara del móvil.',
  'share.linkLabel': 'Enlace para compartir',
  'share.copy': 'Copiar enlace',
  'share.native': 'Compartir…',
  'share.or': 'o',
  'share.pinHint': 'Introduce este PIN en la página de inicio del otro dispositivo.',
  'share.pinLabel': 'PIN de la transferencia',
  'share.copied': 'Copiado al portapapeles',
  'share.shared': 'Compartido',
  'share.linkMessage': 'Abre este enlace para recibir un archivo mío:',
  'share.unavailable': 'Este navegador no tiene menú de compartir del sistema.',
  'clipboard.blocked': 'El navegador bloquea el copiado. Selecciona el enlace y cópialo a mano.',
  'pin.title': '¿Tienes un PIN o un código QR?',
  'pin.text': 'Escribe el código de 9 dígitos que muestra el dispositivo emisor o escanea su código QR.',
  'pin.receive': 'Recibir',
  'pin.scan': '📷 Escanear el código QR',
  'pin.incomplete': 'Introduce los {count} dígitos del PIN.',
  'scan.hint': 'Apunta la cámara al código QR del dispositivo emisor',
  'scan.notOurs': 'Ese código no es un enlace de Sync Port. Busca el que muestra el dispositivo emisor.',
  'camera.denied': 'Se denegó el acceso a la cámara. Permítelo en los ajustes del navegador o escribe el PIN.',
  'camera.notFound': 'No se encontró ninguna cámara en este dispositivo.',
  'camera.busy': 'Otra aplicación está usando la cámara.',
  'camera.failed': 'No se pudo abrir la cámara ({reason}).',
  'sender.status.creatingRoom': 'Creando una sala privada',
  'sender.status.waitingReceiver': 'Esperando a que el receptor abra el enlace',
  'sender.status.receiverConnected': 'Receptor conectado, abriendo un canal directo cifrado',
  'sender.status.waitingDestination': 'Canal cifrado abierto. Esperando a que el receptor elija dónde guardar',
  'sender.status.beaming': 'Enviando el archivo a través del espacio',
  'sender.status.delivered': 'Entregado',
  'status.failed': 'La transferencia falló',
  'progress.sending': 'Enviando',
  'progress.receiving': 'Recibiendo',
  'progress.sentDetail': 'Enviado {sent} · el receptor confirmó {acked}',
  'progress.deliveredDetail': 'El receptor ya tiene el archivo completo.',
  'progress.arrivedDetail': 'Ha llegado hasta el último byte.',
  'progress.of': '{done} de {total}',
  'progress.speedEta': '{speed} · faltan {eta}',
  'route.finding': 'Buscando la mejor ruta',
  'route.direct': 'Conexión directa',
  'route.nat': 'Conexión directa a través de NAT',
  'route.relay': 'Retransmitido por TURN',
  'route.relayOver': 'Retransmitido por TURN mediante {protocol}',
  'sender.sendAnother': 'Enviar otro archivo',
  'receiver.tagline': 'Transmisión entrante por un enlace privado y cifrado. Mantén esta página abierta hasta que aterrice el archivo.',
  'receiver.status.contacting': 'Contactando con el remitente',
  'receiver.status.connected': 'Conectado con el remitente, abriendo un canal directo cifrado',
  'receiver.status.channelOpen': 'Canal cifrado abierto, esperando los detalles del archivo',
  'receiver.status.chooseDestination': 'Elige dónde guardar para empezar a recibir',
  'receiver.status.receiving': 'Recibiendo',
  'receiver.status.complete': 'Completado',
  'dest.title': 'Listo para recibir',
  'dest.picker.button': 'Elegir dónde guardar',
  'dest.picker.text': 'Llegan {size}. Elige un destino y el archivo se escribirá directamente ahí.',
  'dest.worker.button': 'Guardar en este dispositivo',
  'dest.worker.text': 'Llegan {size}. Se escribirá directamente en la carpeta de descargas a medida que llegue.',
  'dest.memory.button': 'Recibir archivo',
  'dest.memory.text': 'Llegan {size}. Este navegador lo mantiene en la pestaña hasta que lo guardes después.',
  'dest.cancelled': 'Elige un destino para empezar a recibir.',
  'landed.title': 'Aterrizó sin problemas',
  'landed.chosenFolder': 'Guardado como {name} en la carpeta que elegiste.',
  'landed.downloads': 'Guardado en la carpeta de descargas del navegador.',
  'landed.openWith': 'Abrir con…',
  'landed.sendYourself': 'Enviar un archivo tú mismo',
  'memory.received': '{size} recibidos. Guárdalo en este dispositivo.',
  'memory.save': 'Guardar archivo',
  'memory.saved': 'Guardado en la carpeta de descargas del navegador. También puedes abrirlo ahora mismo en otra aplicación.',
  'memory.saveAgain': 'Guardar de nuevo',
  'error.inboxNotFound': 'Este número de buzón no existe.',
  'error.inboxUnauthorized': 'La clave no corresponde a este buzón.',
  'error.declined': 'El dueño del buzón rechazó este archivo.',
  'error.inboxLimit': 'No se pueden crear más buzones en este servidor.',
  'home.inboxLink': 'Crear un buzón',
  'inbox.tagline': 'Tu buzón permanente. Quien escanee el código puede ofrecerte un archivo; tú decides qué recibir.',
  'inbox.create.title': 'Crear un buzón',
  'inbox.create.text': 'Obtén un número permanente y un código QR. Quien lo escanee puede ofrecerte un archivo; nada llega hasta que aceptes.',
  'inbox.create.button': 'Crear mi buzón',
  'inbox.connect.title': '¿Ya tienes un buzón?',
  'inbox.connect.text': 'Pega la clave secreta para usar el buzón en este dispositivo. El número es opcional: se puede obtener a partir de la clave.',
  'inbox.connect.numberOptional': 'Número del buzón (opcional)',
  'error.keyUnknown': 'Ningún buzón corresponde a esta clave.',
  'inbox.connect.number': 'Número del buzón',
  'inbox.connect.key': 'Clave secreta',
  'inbox.connect.button': 'Conectar',
  'inbox.key.title': 'Tu clave secreta',
  'inbox.key.text': 'Guarda el número y la clave juntos en un lugar seguro. La clave solo se muestra aquí y, con el número, es la única forma de abrir este buzón en otro dispositivo.',
  'inbox.key.copy': 'Copiar número y clave',
  'inbox.key.copied': 'Número y clave copiados',
  'inbox.key.done': 'Ya los guardé',
  'inbox.number.title': 'Número de tu buzón',
  'inbox.number.text': 'Imprime este código o muéstralo en una pantalla. Los clientes lo escanean o escriben el número en la página de inicio.',
  'inbox.status.connecting': 'Conectando con tu buzón',
  'inbox.status.online': 'En línea. Esperando clientes',
  'inbox.status.reconnecting': 'Conexión perdida. Reconectando',
  'inbox.requests.title': 'Solicitudes entrantes',
  'inbox.requests.empty': 'Aún no hay solicitudes. Aparecerán aquí en cuanto un cliente envíe un archivo.',
  'inbox.request.accept': 'Aceptar y guardar…',
  'inbox.request.decline': 'Rechazar',
  'inbox.request.connecting': 'Aceptado. Conectando con el cliente',
  'inbox.request.cancelled': 'El cliente se fue antes de que respondieras.',
  'inbox.refresh': 'Actualizar',
  'inbox.forget': 'Olvidar este buzón en este dispositivo',
  'toInbox.tagline': 'Enviar un archivo al buzón {number}. El dueño verá tu solicitud y decidirá.',
  'toInbox.status.announcing': 'Anunciando tu archivo al buzón',
  'toInbox.status.waitingOnline': 'Entregado al buzón. Esperando aprobación',
  'toInbox.status.waitingOffline': 'El dueño del buzón no está en línea ahora. Tu solicitud esperará a que vuelva',
  'toInbox.status.accepted': 'Aceptado. Abriendo un canal directo cifrado',
  'inbox.print': 'Imprimir cartel (PDF)',
  'poster.title': 'Envíame tus archivos',
  'poster.number': 'Número del buzón',
  'poster.step1': 'Escanea el código con la cámara del móvil.',
  'poster.step2': 'O abre {link} e introduce el número.',
  'poster.step3': 'Elige el archivo. Lo aceptamos aquí mismo, en el mostrador.',
  'poster.footer': 'Sync Port · cifrado de extremo a extremo, de dispositivo a dispositivo. Nada se guarda en ningún servidor.',
  'install.title': 'Instalar Sync Port',
  'install.native': 'Añádela a tu pantalla de inicio para acceder rápidamente.',
  'install.ios': 'Toca «Compartir» y luego «Añadir a pantalla de inicio».',
  'install.button': 'Instalar',
};
